import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { INonComplianceDetails } from "../../../api/INonCompliance";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldEmpty from "../../../leap-components/EpaFieldEmpty";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";
import {
  GetComplaintDetailsPageUrl,
  GetIncidentPageUrl,
  GetLicenseeReturnPageUrl,
} from "../../routeFactory";

interface NonComplianceDetailsProps {
  nonComplianceDetails: INonComplianceDetails;
}

const NonComplianceDetails = ({
  nonComplianceDetails,
}: NonComplianceDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Non-Compliance Occurred"}
            value={nonComplianceDetails.dateofnoncompliance}
          />
          <EpaField
            label={"Date Issued by EPA"}
            value={nonComplianceDetails.datesubmitted}
          />
          <EpaField
            label={"Non Compliance Type"}
            value={nonComplianceDetails.subject}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date of Notification to EPA"}
            value={nonComplianceDetails.dateofnotification}
          />
          <EpaField
            label={"Authorisation Condition Number"}
            value={nonComplianceDetails.condition}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-6">
          {nonComplianceDetails.incidentDetails && (
            <EpaField
              label={"Related Incident"}
              value={
                <Link
                  to={GetIncidentPageUrl(
                    nonComplianceDetails.licenceDetails.licenceprofile_number,
                    nonComplianceDetails.incidentDetails.incidentid
                  )}
                >
                  {nonComplianceDetails.incidentDetails.reference}
                </Link>
              }
            />
          )}
          {!nonComplianceDetails.incidentDetails && (
            <EpaFieldEmpty label={"Related Incident"} />
          )}
          {nonComplianceDetails.licenseeReturnDetails && (
            <EpaField
              label={"Related Licensee Return"}
              value={
                <Link
                  to={GetLicenseeReturnPageUrl(
                    nonComplianceDetails.licenceDetails.licenceprofile_number,
                    nonComplianceDetails.licenseeReturnDetails.licenseereturnid
                  )}
                >
                  {nonComplianceDetails.licenseeReturnDetails.reference}
                </Link>
              }
            />
          )}
          {!nonComplianceDetails.licenseeReturnDetails && (
            <EpaFieldEmpty label={"Related Licensee Return"} />
          )}
        </Col>
        <Col className="col-12 col-md-6">
          {nonComplianceDetails.complaintDetails && (
            <EpaField
              label={"Related Complaint"}
              value={
                <Link
                  to={GetComplaintDetailsPageUrl(
                    nonComplianceDetails.licenceDetails.licenceprofile_number,
                    nonComplianceDetails.complaintDetails.complaintid
                  )}
                >
                  {nonComplianceDetails.complaintDetails.reference}
                </Link>
              }
            />
          )}
          {!nonComplianceDetails.complaintDetails && (
            <EpaFieldEmpty label={"Related Complaint"} />
          )}
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Description"}
            value={nonComplianceDetails.description}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Non Compliance Details"} content={bodyElements} />;
};

export default NonComplianceDetails;
